export default __webpack_public_path__ + "static/media/ic-animals-beef.39b9a276.svg";